const NavbarContent = {
  filmmakerName: "Kaveri Sharma",
  menuItems: ["Movies", "Photography", "Writing", "About"],
};

export default NavbarContent;
